import { Component } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: '회사소개', routerLink:"/about", icon: 'mail' },
    { title: '다운로드', routerLink:"/download", icon: 'paper-plane' },
  ];
  constructor() {}
}
